export const LE_TOUR_TYPES = [
  'direct_tour',
  'ultra_lux_tour',
  'partner_tour',
  'signature_series_tour',
  'classic_tour',
  'deluxe_tour',
  'premium_tour',
  'custom_tour',
  'insider_series_tour',
];

export const TOUR_TRAVELLER_REQUIREMENT_DOCUMENT = [
  'INVITATION_LETTER',
  'VISA',
  'PASSPORT_PHOTO',
  'PASSPORT_FILE',
] as const;
export type TourTravellerRequirementDocument = (typeof TOUR_TRAVELLER_REQUIREMENT_DOCUMENT)[number];

export const TOUR_TRAVELLER_REQUIREMENT_DOCUMENT_LABELS = {
  INVITATION_LETTER: 'Letter of Invitation Form',
  VISA: 'Copy of Visa into Destination country',
  PASSPORT_PHOTO: 'Passport-Sized Photo',
  PASSPORT_FILE: 'Passport File',
} as const;
